import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { CampaignQueryVariables, GetCampaignResponse } from '../types';
import { Mc3Client } from './client';
import { campaignQueryKeys } from './queryKeys';

export function useCampaigns(variables: CampaignQueryVariables) {
  const { data, ...query } = useQuery({
    queryKey: campaignQueryKeys.list(variables),
    queryFn: async () => {
      const searchParams = new URLSearchParams();

      Object.entries(variables).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          searchParams.append(key, String(value));
        }
      });

      const response = await Mc3Client.get('api/campaigns', {
        searchParams,
      }).json<GetCampaignResponse>();

      return response;
    },
    placeholderData: keepPreviousData,
  });

  return {
    campaigns: data?.campaigns,
    totalCount: data?.total_count,
    ...query,
  };
}
